var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "promotion" }, [
      _c("div", { staticClass: "worp" }, [
        _c("div", { staticClass: "p_left" }, [
          _c("img", { attrs: { src: require("@/assets/app.png"), alt: "" } }),
        ]),
        _c("div", { staticClass: "p_right" }, [
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/dllogo.png"), alt: "" },
            }),
          ]),
          _c("div", { staticClass: "p_code" }, [
            _c("img", {
              attrs: { src: require("@/assets/code.png"), alt: "" },
            }),
          ]),
          _c("div", { staticClass: "p_text" }, [
            _vm._v("手机扫码下载科普中国APP"),
          ]),
          _c("div", { staticClass: "p_btn" }, [
            _c("button", { staticClass: "pb_left", attrs: { type: "text" } }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://apps.apple.com/cn/app/id1114665048",
                    target: "_blank",
                  },
                },
                [
                  _c("span", [_c("i", { staticClass: "fa fa-apple" })]),
                  _c("span", [_vm._v("iPhone")]),
                  _c("span", [_vm._v("下载")]),
                ]
              ),
            ]),
            _c("button", { staticClass: "pb_right", attrs: { type: "text" } }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://sj.qq.com/myapp/detail.htm?apkName=com.sevenplus.chinascience&info=B23404625FD2478FE48400E98D032590",
                    target: "_blank",
                  },
                },
                [
                  _c("span", [_c("i", { staticClass: "fa fa-android" })]),
                  _c("span", [_vm._v("Android")]),
                  _c("span", [_vm._v("下载")]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }